;(function() {
  'use strict'

  angular.module('core.kitSections', [])
})()
